module.exports = __webpack_public_path__ + "img/ja_get.ac84ad0.png";